import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Transition } from '../TransitionGroup';
import { defaultProps, initialState, propTypes } from './WaterDrop.types';
import styled, { css, keyframes } from 'styled-components';
import { mapColorLabelToHex } from '../../helpers/colorStyle.helper';
import { easing, duration } from '../animation';
var animateEnter = keyframes(["0%{transform:scale(0);opacity:0.1;}100%{transform:scale(1);opacity:0.3;}"]);
var animateExit = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
var animatePulsate = keyframes(["0%{transform:scale(1);}50%{transform:scale(0.92);}100%{transform:scale(1);}"]);
var childPulsate = css(["", ";"], function (_ref) {
  var pulsate = _ref.pulsate;
  return pulsate && "\n      position: absolute;\n      left: 0;\n      top: 0;\n      animation: ".concat(animatePulsate, " 2500ms ").concat(easing.easeInOut, " 200ms infinite;\n      ");
});
var childLeaving = css(["", ";"], function (_ref2) {
  var leaving = _ref2.leaving,
      duration = _ref2.duration;
  return leaving && "\n    opacity: 0;\n    animation: ".concat(animateExit, " ").concat(duration, "ms ").concat(easing.easeInOut, ";\n  ");
});
var RippleChild = styled.span.withConfig({
  displayName: "WaterDrop__RippleChild",
  componentId: "sc-1btdjm2-0"
})(["opacity:1;display:block;width:100%;height:100%;border-radius:50%;background-color:currentColor;", ";color:", ";"], childLeaving, function (_ref3) {
  var color = _ref3.color;
  return mapColorLabelToHex(color);
});
var rippleVisible = css(["", ";"], function (_ref4) {
  var visible = _ref4.visible,
      duration = _ref4.duration;
  return visible && "\n      opacity: 0.3;\n      transform: scale(1);\n      animation: ".concat(animateEnter, " ").concat(duration, "ms ").concat(easing.easeInOut, ";\n      ");
});
var ripplePulsate = css(["", ";"], function (_ref5) {
  var pulsate = _ref5.pulsate;
  return pulsate && "\n      ".concat(duration.shorter, "ms;\n      ");
});
var RippleParent = styled.span.withConfig({
  displayName: "WaterDrop__RippleParent",
  componentId: "sc-1btdjm2-1"
})(["width:50px;height:50px;left:0;top:0;opacity:0;position:absolute;color:currentColor;", ";"], rippleVisible);

var WaterDrop =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WaterDrop, _React$Component);

  function WaterDrop() {
    var _this;

    _classCallCheck(this, WaterDrop);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WaterDrop).apply(this, arguments));
    _this.state = initialState;

    _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    };

    _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    };

    return _this;
  }

  _createClass(WaterDrop, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          pulsate = _a.pulsate,
          rippleX = _a.rippleX,
          rippleY = _a.rippleY,
          rippleSize = _a.rippleSize,
          timeout = _a.timeout,
          duration = _a.duration,
          color = _a.color,
          other = __rest(_a, ["pulsate", "rippleX", "rippleY", "rippleSize", "timeout", "duration", "color"]);

      var _this$state = this.state,
          visible = _this$state.visible,
          leaving = _this$state.leaving;
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      return React.createElement(Transition, _extends({
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        timeout: timeout,
        render: function render(_state, _ref6) {
          var setTransitionRef = _ref6.setTransitionRef;
          return React.createElement(RippleParent, {
            innerRef: setTransitionRef,
            style: rippleStyles,
            visible: visible,
            pulsate: pulsate,
            duration: duration
          }, React.createElement(RippleChild, {
            leaving: leaving,
            pulsate: pulsate,
            duration: duration,
            color: color
          }));
        }
      }, other));
    }
  }]);

  return WaterDrop;
}(React.Component);

WaterDrop.propTypes = propTypes;
WaterDrop.defaultProps = defaultProps;
export { WaterDrop };